
import { Component, Vue, Prop } from 'vue-property-decorator';
import CookieLaw from 'vue-cookie-law';

type Lang = 'el' | 'en';

@Component({
  components: { CookieLaw },
})
export default class Cookies extends Vue {
  @Prop({
    type: String,
    default: 'en',
    validator(value: any) {
      return ['el', 'en'].includes(value);
    },
  })
  readonly lang!: Lang;

  get text() {
    return this.lang === 'en'
      ? 'We are using cookies to ensure you get the best experience on our website.'
      : 'Χρησιμοποιούμε cookies για να διασφαλίσουμε ότι θα έχετε την καλύτερη εμπειρία στον ιστότοπό μας.';
  }

  get buttonText() {
    return this.lang === 'en' ? 'Got it!' : 'Το κατάλαβα!';
  }
}
